import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLogin: false,
  currentUser: {},
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCurrentUser(state, action) {
      state.currentUser = action.payload;
      state.isLogin = true;
    },
    logOut(state) {
      state.isLogin = false;
      state.currentUser = {};
    },
  },
});

export const { setCurrentUser, logOut } = authSlice.actions;
const authReducer = authSlice.reducer;

export default authReducer;
